<div class="modal-header1">
  <app-page-content-header
    pageTitle="Incoming call"
    [isPopUp]="true"
    style="border: 0px !important; padding: 0px !important"
  />
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="clickHandlerBack()"
  ></button>
</div>

<div class="modal-body">
  <div class="py-1">
    <app-new-call-container
      (ToggleMic)="toggleMic()"
      (EndCall)="endCall()"
      [isOnCall]="isOnCall"
      [mute]="mic"
      [formattedTime]="formatCallDuration(callDuration)"
      [showKeypad]="false"
      [showProfileButton]="!!data.patientId"
      (ViewProfile)="openPatientProfileInNewTab()"
      [clinicName]="data.clinic || ''"
      [patientName]="data.name || ''"
    />

    <div class="bottom-container">
      <div class="left-container">
        <div class="header">Transfer the Active Call</div>

        <div>
          <app-select
            [label]="translate('USERTYPE')"
            [isRequired]="true"
            [items]="groups"
            formControlValue="userType"
            [formGroup]="transferCallForm"
            formName="transferCallForm"
          />

          <app-select
            [label]="translate('USER')"
            [isRequired]="true"
            [items]="users"
            formControlValue="user"
            [formGroup]="transferCallForm"
            formName="transferCallForm"
          />
        </div>

        <div class="d-flex gap-1">
          <button
            class="btn btn-primary w-100 mt-2"
            [disabled]="transferCallForm.invalid"
            (click)="transferCall()"
          >
            Dial Agent
          </button>
          <button
            class="btn btn-primary w-100 mt-2 end"
            style="border: 0"
            [disabled]="transferCallForm.invalid"
            (click)="leaveCall()"
          >
            Leave
          </button>
        </div>
      </div>

      <div class="mid-container">
        <div class="header mid">Transfer the Active Call</div>

        <div>
          <div class="info-title">Contacts In Queue</div>
          <div class="info">{{ queueList.length }}</div>
        </div>

        <div>
          <div class="info-title">Longest Wait</div>
          <div class="info">00:00</div>
        </div>

        <div>
          <div class="info-title number">
            {{ getOldestQueueNumber() }}
          </div>
          <div class="status">
            {{ getOldestQueueName() || "Not Exist" }}
          </div>
        </div>
        <div style="margin-top:auto">
          <button
            class="btn btn-primary w-100 mt-2 green-btn"
            (click)="pickUpNextCall()"
          >
            Pick Next Call
          </button>
        </div>
      </div>
      <!-- <div>
          <div class="info-title">Longest Wait</div>
          <div class="info">{{ getLongestWaitTime() }}</div>
        </div> -->
      <!-- <div class="incoming-call-list">
        <div class="incoming-call-container" *ngFor="let call of incomingCalls">
          <div class="incoming-call">
            <div class="infoo">
              <div class="avatar" aria-hidden="true">
                {{ getInitials(call.name || "") }}
              </div>
              <div
                class="meta"
                role="button"
                tabindex="0"
                [attr.aria-pressed]="isSwapped"
                [attr.title]="call.name"
              >
                <div class="stack" [class.swapped]="isSwapped">
                  <div class="line top">{{ call.number }}</div>
                </div>
                <div class="clinic">{{ call.name }} - {{ call.clinic }}</div>
              </div>
            </div>
          </div>

          <div class="btn-group">
            <div class="circle-btn">
              <svg
                width="12"
                height="12"
                viewBox="0 0 22 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="idkIcon"
              >
                <path
                  d="M14.1124 17.3685L12.4115 17.6222C12.0038 17.6822 11.6454 17.926 11.4401 18.2816L10.5651 19.7972C8.47491 19.3521 6.56546 18.2574 5.13244 16.6606L6.01081 15.1392C6.21609 14.7837 6.24807 14.3514 6.09617 13.9683L5.46792 12.3776C5.21362 11.7412 4.52892 11.3925 3.86692 11.5699L2.74521 11.8704C2.00965 12.0675 1.56206 12.8428 1.80512 13.566C3.63671 19.0224 9.26754 22.2734 14.9087 21.1314C15.6566 20.9803 16.1042 20.205 15.9071 19.4695L15.6066 18.3478C15.435 17.6891 14.7907 17.2705 14.1124 17.3685Z"
                  fill="white"
                />
                <path
                  d="M13.5999 0C9.35949 0 5.92188 3.43762 5.92188 7.67806C5.92188 11.9185 9.35949 15.3561 13.5999 15.3561C17.8404 15.3561 21.278 11.9185 21.278 7.67806C21.278 3.43762 17.8404 0 13.5999 0ZM9.73666 6.06163H8.48123V5.25341H11.5282C11.5282 5.25341 11.5794 5.59286 11.5794 5.79222C11.5794 6.31218 11.1564 6.73514 10.6365 6.73514C10.2108 6.73514 9.8525 6.44957 9.73666 6.06163ZM15.871 10.426C14.2519 10.135 12.657 10.4529 11.4932 11.2935L11.019 10.6388C12.358 9.66897 14.1792 9.30258 16.0111 9.63125L15.871 10.426ZM17.641 6.73514C17.2154 6.73514 16.8571 6.44957 16.7412 6.06163H15.4858V5.25341H18.5328C18.5328 5.25341 18.5839 5.59286 18.5839 5.79222C18.5839 6.31218 18.161 6.73514 17.641 6.73514Z"
                  fill="white"
                />
              </svg>
            </div>

            <div class="circle-btn call" (click)="addToQueue(call)">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3607 7.46515C10.5384 7.98014 10.3732 8.70124 9.8829 9.55081C9.36476 10.4476 8.80361 10.9883 8.25868 11.1151C8.1454 11.1414 8.02583 11.1235 7.92514 11.0653L7.54702 10.8472C7.37815 10.7491 7.31994 10.533 7.41748 10.3636L7.78878 9.72067C7.88633 9.5518 8.10291 9.49359 8.27179 9.59113L8.40605 9.66875L8.43227 9.64095H8.43279C8.77473 9.27857 9.02698 8.84172 9.17067 8.36448L9.18169 8.32777L9.04638 8.24963C8.9651 8.20295 8.90583 8.12586 8.88171 8.03513C8.85706 7.9444 8.87017 7.84791 8.91684 7.76662L9.28814 7.12366C9.38568 6.95479 9.60227 6.89658 9.77115 6.99412L10.1556 7.21595C10.2515 7.27154 10.3245 7.35973 10.3607 7.46515ZM11.8627 9.03688C11.8617 9.82248 11.5496 10.5756 10.9937 11.131C10.4383 11.6869 9.68525 11.9989 8.8996 12C8.23147 12.0021 7.58222 11.7755 7.06044 11.3581L6.99751 11.3083L6.98335 11.3875H6.98282C6.92041 11.7341 6.61834 11.9869 6.26592 11.9864H0.728966C0.326724 11.9858 0.000523596 11.6596 0 11.2574V9.91588C0 8.56447 0.769874 7.62522 2.16702 7.27065L2.26089 7.24705L2.18537 7.18674C1.76373 6.85005 1.48787 6.36338 1.41497 5.82848C1.3426 5.29355 1.47843 4.75129 1.79518 4.31394C2.11142 3.87656 2.58446 3.57816 3.11518 3.4801L3.1477 3.47433L3.15347 3.44181H3.15399C3.23213 3.02383 3.43456 2.63942 3.73506 2.33893C4.03557 2.03844 4.41998 1.83547 4.83794 1.75734L4.87046 1.75157L4.87623 1.71905H4.87675C4.99685 1.07085 5.41377 0.516527 6.00271 0.221837C6.59217 -0.0728939 7.286 -0.073941 7.87598 0.21869C8.46648 0.511327 8.88551 1.06408 9.00771 1.71174C9.1299 2.35889 8.9411 3.02651 8.49795 3.51426C8.41929 3.60079 8.33328 3.6805 8.2415 3.75287L8.16546 3.81265L8.25881 3.8373C9.64956 4.20178 10.4242 5.14052 10.4394 6.48052L10.4399 6.50674L10.4625 6.5209C11.3346 7.05897 11.8648 8.01181 11.8627 9.03711L11.8627 9.03688ZM5.16941 1.72211L5.23077 1.72263H5.23025C5.78353 1.72683 6.3132 1.94867 6.70437 2.3399C7.0956 2.73166 7.31691 3.26081 7.32111 3.81402L7.32164 3.87538L7.3809 3.8607C8.01495 3.70284 8.51525 3.21616 8.68989 2.58632C8.86453 1.957 8.68674 1.28205 8.22524 0.820055C7.76322 0.357505 7.08826 0.179724 6.45844 0.35435C5.82912 0.528989 5.34192 1.02877 5.18406 1.66282L5.16941 1.72211ZM3.44611 3.44487L3.50747 3.4454C4.06075 3.44959 4.59043 3.67143 4.98159 4.06266C5.37283 4.4539 5.59413 4.98357 5.59833 5.53679L5.59886 5.59815L5.65812 5.58346C6.29217 5.4256 6.79195 4.93841 6.96711 4.30908C7.14175 3.67924 6.96396 3.00428 6.50194 2.54228C6.03992 2.08028 5.3655 1.90248 4.73568 2.07712C4.10586 2.25176 3.61916 2.75153 3.46078 3.38558L3.44611 3.44487ZM3.4975 7.35921C4.23066 7.35921 4.89148 6.91763 5.17207 6.24007C5.45264 5.56302 5.29741 4.78313 4.77927 4.26504C4.2606 3.74637 3.48129 3.59167 2.8037 3.87224C2.12665 4.15228 1.68508 4.81359 1.68508 5.5468C1.68613 6.54742 2.49689 7.35814 3.4975 7.35921ZM11.5738 9.03688C11.5738 8.32785 11.2922 7.6476 10.7908 7.14576C10.2894 6.64439 9.60873 6.36278 8.89968 6.36278C8.19064 6.36278 7.51041 6.64441 7.00856 7.14576C6.5072 7.64764 6.22559 8.32783 6.22559 9.03688C6.22559 9.74592 6.50721 10.4262 7.00856 10.928C7.51045 11.4294 8.19064 11.711 8.89968 11.711C9.60871 11.7105 10.2884 11.4283 10.7897 10.927C11.291 10.4256 11.5733 9.74589 11.5738 9.03688Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      </div> -->

      <div class="incoming-call-list" style="max-height: 250px;" *ngIf="summarySaved">
        <div class="info-title">Notes</div>
        <textarea
          class="w-100 notes-textarea"
          placeholder="Notes"
          rows="10"
          [(ngModel)]="notes"
        ></textarea>
        <button
          class="btn btn-primary w-100 mt-2 green-btn"
          type="button"
          (click)="approveCall()"
          style="align-self:flex-end"
        >
          Approve
        </button>
      </div>
    </div>
  </div>
</div>

